// @flow
import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { Input } from '@fortress-technology-solutions/fortress-component-library/Atoms';
import { Grid } from '@fortress-technology-solutions/fortress-component-library/Molecules';
import { SetupCheckbox } from '../Programs/shared';
import messages from './messages';

const MIN_WEIGHT = 0;

type PreferenceOption = {
  id: string,
  weight: number,
  enabled: boolean,
};

type Props = {
  option: PreferenceOption,
  editMode: boolean,
  usePreferences: boolean,
  handlePreferenceChange: (id: string, field: string, value: any) => void,
};

function PreferenceRow({
  option,
  editMode,
  usePreferences,
  handlePreferenceChange,
}: Props) {
  const [weightInput, setWeightInput] = useState(String(option.weight));

  // Sync local state if the value changes externally (e.g. server refresh)
  useEffect(() => {
    setWeightInput(String(option.weight));
  }, [option.weight]);

  const handleWeightChange = (evt) => {
    const raw = evt.target.value;
    // Allow empty string (backspace to clear) and up to 3 digits only
    if (raw === '' || /^\d{1,3}$/.test(raw)) {
      setWeightInput(raw);
    }
  };

  const handleWeightBlur = () => {
    const parsed = parseInt(weightInput, 10);
    const clamped = isNaN(parsed) ? MIN_WEIGHT : Math.max(MIN_WEIGHT, parsed);
    setWeightInput(String(clamped));
    handlePreferenceChange(option.id, 'weight', clamped);
  };

  return (
    <Grid container alignItems="center" sx={{ mb: '4px' }}>
      <SetupCheckbox
        checkboxId={`waitlist-v2-preference-${option.id}`}
        name={`setup.preference.${option.id}`}
        label={<FormattedMessage {...messages[option.id]} />}
        value={option.enabled}
        editMode={editMode}
        disabled={!usePreferences}
        onChange={(evt) =>
          handlePreferenceChange(option.id, 'enabled', evt.target.value)
        }
      />
      <Grid item xs={3}>
        <Input
          type="number"
          id={`waitlist-v2-preference-weight-${option.id}`}
          name={`setup.preference.${option.id}`}
          value={weightInput}
          disabled={!option.enabled || !editMode || !usePreferences}
          helperText={null}
          onChange={handleWeightChange}
          onBlur={handleWeightBlur}
          inputProps={{ min: MIN_WEIGHT }}
        />
      </Grid>
    </Grid>
  );
}

export default PreferenceRow;
